import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { getLanguageName, getLanguageNativeDisplay } from "../../utils/languageUtils";

/**
 * 剧集上下文 meta pill 文案：`剧集名` 或 `剧集名 · 语种（母语）`。
 * 原是 PremiumWorkspaceLayout 顶栏 meta，Header 移除后由视频列表页自行渲染。
 * @param showLang 是否需要追加语种后缀（视频列表页带 langCode 时为 true）
 */
export function useSeriesContextMeta(showLang: boolean): string {
  const [searchParams] = useSearchParams();

  const rawName = searchParams.get("seriesName") ?? "";
  const decodedSeriesName = useMemo(() => {
    if (!rawName) return "";
    try {
      return decodeURIComponent(rawName);
    } catch {
      return rawName;
    }
  }, [rawName]);

  const name = decodedSeriesName || "未命名剧集";

  if (!showLang) return name;

  const code = (searchParams.get("langCode") ?? "").trim();
  if (!code) return name;

  const isFromQuick = searchParams.get("from") === "quick";
  const langNameFromUrl = isFromQuick
    ? searchParams.get("targetLangName")?.trim()
    : searchParams.get("langName")?.trim();
  const zh = langNameFromUrl || getLanguageName(code);
  const native = getLanguageNativeDisplay(code);
  const showNative = native && native !== zh && native.toLowerCase() !== zh.toLowerCase();
  const langLabel = showNative ? `${zh}（${native}）` : zh;
  return `${name} · ${langLabel}`;
}
